var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotivatedTeamsStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9653_7891)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.59998,
    width: 44,
    height: 12,
    fill: "#9AB853"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: 12,
    width: 48.8,
    height: 12,
    fill: "#FCF185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 12,
    width: 31.2,
    height: 12,
    fill: "#CBDB60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9653_7891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivatedTeamsStack);
export default __webpack_public_path__ + "static/media/motivated-teams-stack.bf9b15d6074e0ab8c44ad28317a26639.svg";
export { ForwardRef as ReactComponent };